import ListWMDSResult from '../WMDS.Result.i18n';
import ListWSFinderResult from '../WSFinder.Result.i18n';
import { Switch as cSwitch } from '@coreui/vue'

export default {
  props : ['auto_refresh'],
  components: { ListWMDSResult, ListWSFinderResult, cSwitch },
  data: () => ({ base: true, list_wsfinder_result : false, lsit_wmds_result : false, sync : { th : undefined, interval : 15, run : false } }),
  methods: {
    refresh() {

      clearTimeout(this.sync.th)
      this.sync.th = undefined;

      if(this.sync.run) {

        if(this.$refs.list_wsfinder_result) { this.$refs.list_wsfinder_result.$children.forEach(x => x.refresh()); }
        if(this.$refs.list_wmds_result) { this.$refs.list_wmds_result.$children.forEach(x => x.refresh()); }

        console.log("integrity", "refresh")
      }
      this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval );

    },
    pause: function() { this.sync.run = !this.sync.run; this.refresh(); },
    select({ id, tag }) {
      this.list_wsfinder_result = this.lsit_wmds_result = true;
      if(!this.sync.th) { this.refresh() }
    },
    SyncClear() {
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; console.debug("integtiry", "sync", "clear") }
    },
  },
  watch: {
    '$route' (to, from) {
      console.log('integrity.vue', 'route changed', to.param), from;
      this.select(to.params);
    }
  },
  created() { console.log('integrity.vue', 'created'); },
  destroyed() { console.log('integrity.vue', 'destroyed'); this.SyncClear() },
  mounted() { console.log('integrity.vue', 'mounted'); this.select(this.$route.params); },
}
